import { CdkMenuModule } from "@angular/cdk/menu";
import { CommonModule } from "@angular/common";
import {
    afterNextRender,
    Component,
    HostBinding,
    inject,
    input,
    signal,
} from "@angular/core";
import { Router } from "@angular/router";
import { AlertService, Icon } from "@malirang/front-share";
import { injectNavigationEnd } from "ngxtension/navigation-end";
import { MenuItem } from "../../layout.component";

@Component({
    selector: "app-menus",
    templateUrl: "./menus.component.html",
    styleUrls: ["./menus.component.css"],
    imports: [CommonModule, CdkMenuModule, Icon],
})
export class MenusComponent {
    private alertService = inject(AlertService);
    readonly router = inject(Router);
    readonly navigationEnd$ = injectNavigationEnd();
    @HostBinding("class") class = "w-full";

    path = signal<string>("");
    menus = input.required<MenuItem[]>();

    handleNavigate(ev: any, item: MenuItem) {
        ev.preventDefault();
        ev.stopPropagation();
        if (item?.disabled) {
            this.alertLoginBlock();
            return;
        }

        if (item.url === "document") {
            this.router.navigate([item.url], {
                queryParams: {
                    prevUrl: this.router.url,
                },
            });
            return;
        }

        if (!item.children || !item.children.length) {
            if (item.url.startsWith("http")) {
                window.open(item.url, "_blank");
                return;
            }
            this.router.navigate([item.url]);
        }
    }

    constructor() {
        afterNextRender(() => {
            this.path.set(this.router.url);
            this.navigationEnd$.subscribe(() => {
                this.path.set(this.router.url);
            });
        });
    }

    alertLoginBlock(): void {
        this.alertService.open({
            type: "info",
            icon: { name: "solar:danger-circle-bold", color: "primary" },
            title: "서비스 준비중",
            content: "서비스 준비중입니다.",
            buttons: {
                confirm: { hidden: true },
                cancel: { text: "확인", color: "primary" },
            },
        });
    }
}
